// material-ui
import { useTheme } from "@mui/material/styles";
import {
  useMediaQuery,
  Grid,
  List,
  ListItem,
  Stack,
  Typography,
} from "@mui/material";

// project import
import MainCard from "components/MainCard";
import { FormattedMessage, useIntl } from "react-intl";
// types

// ==============================|| EXPANDING TABLE - USER DETAILS ||============================== //

const ExpandingCategoryDetail = ({ data }: any) => {
  const theme = useTheme();
  const matchDownMD = useMediaQuery(theme.breakpoints.down("md"));

  console.log("data", data);
  return (
    <Grid
      container
      spacing={3.5}
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <Grid item xs={12} sm={7} md={12} xl={8.5}>
        <Stack spacing={2.5}>
          <MainCard title= <FormattedMessage id="Email Template Details" />  >
            <List sx={{ py: 0 }}>
              <ListItem divider={!matchDownMD}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary"><FormattedMessage id="User Type" /></Typography>
                      <Typography>{data?.user_type}</Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary"><FormattedMessage id="Email Type" /></Typography>
                      <Typography>{data?.mail_type}</Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem divider={!matchDownMD}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary"> <FormattedMessage id="English Title" /></Typography>
                      <Typography>{data?.title}</Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary"><FormattedMessage id="Arabic Title" /></Typography>
                      <Typography>{data?.title_trans?.ar}</Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem divider={!matchDownMD}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={12}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary"><FormattedMessage id="English Message" /></Typography>
                      <Typography
                        dangerouslySetInnerHTML={{ __html: data?.body || "" }}
                      />
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary"><FormattedMessage id="Arabic Message" /></Typography>
                      <Typography
                        dangerouslySetInnerHTML={{
                          __html: data?.body_trans?.ar || "",
                        }}
                      />
                    </Stack>
                  </Grid>
                </Grid>
              </ListItem>
            </List>
          </MainCard>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default ExpandingCategoryDetail;
